export default {
  headline: "Laufzettel",
  name: "Name, Vorname",
  belehrung_bereiche_headline: "Belehrungen / Einweisungen in den einzelnen Bereichen",
  hr_department: "a) Personalabteilung",
  accounting: "b) Buchhaltung",
  qm_system: "QM-System",
  betriebsausweis: "Betriebsausweis",
  documents: "Dokumente",
  cashbox: "c) Kasse",
  cashbox_2: "Kassenabrechnung, Fahrscheine, Fahrpläne, Wechselgeld, sonst. Modulabrechnungen",
  verkehrsplanung: "Verkehrsplanung",
  einweisung_tarifsystem: "Einweisung Tarifsystem",
  fahrscheinsortiment: "Fahrscheinsortiment",
  fuhrpark: "Fuhrpark / Betriebshöfe",
  sozialvorschriften: "Sozialvorschriften",
  arbeits_umweltschutz: "Arbeits- und Umweltschutz",
  werkstatt: "Werkstatt",
  werkstatt_arbeitsablaeufe: "Arbeitsabläufe",
  werkstatt_arbeitsbelehrung: "Arbeitsschutzbelehrung / Umweltschutz",
  weitere_belehrungen: "Weitere Belehrungen über",
  betriebsordnung: "Betriebsordnung",
  betriebsverkehrsordnung: "Betriebsverkehrsordnung",
  tarifangelegenheiten: "Tarifangelegenheiten",
  fahrzeugbordrechner: "Fahrzeugbordrechner",
  monats_wochen_tagesplan: "Einweisung Monats- / Wochen- / Tagesplan",
  fahrzeugeinweisung: "Fahrzeugeinweisung zum Umgang mit der Technik",
  einweisung_ueber: "Einweisung über:",
  einweisung_tanken: "Tanken",
  einweisung_einzahlungen: "Einzahlungen",
  einweisung_abrechnung: "Abrechnung",
  einweisung_rbl: "RBL",
  empfang_rueckgabe: "Empfang/Rückgabe von:",
  erhalt: "Empfang",
  rueckgabe: "Rückgabe",
  employee: "Mitarbeiter",
  foreman: "Vorgesetzter",
  betriebsschluessel: "Betriebsschlüssel",
  transponder_schliesssystem: "Transponder Schließsystem",
  rfid_im_transponder: "RFID im Transponder hinterlegt",
  tanktransponder_gesondert: "Tanktransponder gesondert. (RFID)",
  tresor: "Tresor",
  spind: "Spind",
  modul: "Modul",
  wechselgeld: "Wechselgeld",
  kasseneinsatz: "Krauth Kasseneinsatz (Wechsler)",
  dienstkleidung: "Dienstkleidung",
  infoblatt_betriebliche_alertsvorsorge: "Informationsblatt Betriebliche Altersvorsorge",
  handy_privat: "Handy Privat",
  handynummer: "Mobilfunknummer",
  fahrerdongle: "Fahrer Dongle",
  imei: "Handytyp/ IMEI",
  handy_sim: "Handy-SIM",
  sonstiges: "Sonstiges",
  sonstiges_eintragen: "(eintragen)",
  fachabteilung: "Fachabteilung",
  verkaeufernummer: "Verkäufernummer angelegt",
  konten_prema: "Konten in PREMA angelegt",
  fahrerkontofuehrung: "Fahrerkontoführung angelegt",
  tanksystem: "Tanksystem angelegt",
  edv: "EDV",
  personal: "Personal",
  buchhaltung: "Buchhaltung",
  technik: "Technik"
}
